// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aa7ea509","703":"0326efee","787":"e4d565d4"}[chunkId] + ".chunk.js";
};